const InfoCardGrid = ({ items = [], onClick, className = "", bgClass = "bg-white" }) => {
    if (!items.length) return null;

    return (
        <div className="mx-auto max-w-7xl px-3 py-6 sm:px-3 lg:px-6 ">
            <div className={`rounded-2xl border border-slate-200 shadow-sm ${bgClass} ${className}`}>
                <div className="flex flex-col divide-y divide-slate-100 md:flex-row md:divide-x md:divide-y-0">
                    {items.map((item, index) => (
                        <div
                            key={item.id || index}
                            onClick={() => onClick && onClick(item)}
                            className="group flex flex-1 cursor-pointer items-center  gap-2 p-4 transition-colors duration-150 hover:bg-blue-50/50 md:flex-col lg:flex-row"
                        >
                            {/* Icon */}
                            <div className="flex h-10 w-10 primary-bg shrink-0 items-center justify-center rounded-full">
                                <img
                                    src={item.image}
                                    alt={item.title}
                                    className="h-5 w-5 object-contain"
                                />
                            </div>

                            {/* Content */}
                            {/* <div className="min-w-0 flex-1"> */}
                            <div className="min-w-0 flex-1 flex flex-col md:justify-center md:items-center md:text-center">
                                {/* <p className="mb-1 font-semibold text-sm primary-text"> */}
                                {/* <p className="mb-1 font-semibold text-xs sm:text-sm lg:text-base primary-text"> */}
                                <p className="mb-1 font-semibold text-[11px] sm:text-xs lg:text-sm primary-text">
                                    {item.title}
                                </p>
                        
                                {/* <p className="text-[11px] leading-relaxed primary-text"> */}
                                <p className="text-[10px] sm:text-xs lg:text-sm leading-relaxed primary-text">
                                    {item.description}
                                </p>
                                {item.description2 && (
                                    <p className="text-[10px] sm:text-xs lg:text-sm leading-relaxed primary-text">
                                        {item.description2}
                                    </p>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default InfoCardGrid;